import { handleClickOutside } from "./helpers/click-outside-handler";
import { removeOpenedClass } from "./helpers/remove-opened-class";

const NavigationMenu = () => {
  const menuWrappers = [...document.querySelectorAll(".header__menus-wrapper ul li")];
  const body = document.body;

  // const openNavigationMenu = (menu, opener, openableLinks, rightAdditionalLinks) => {
  //   menuWrappers.forEach((menuWrapper) => {
  //     const menu = menuWrapper.querySelector(".navigation-menu");
  //     const opener = menuWrapper.querySelector(".header__menu-opener-link");
  //     closeNavigationMenu(menu, opener, openableLinks, rightAdditionalLinks);
  //   });

  //   menu.classList.add("opened");
  //   opener.classList.add("opened");
  //   body.classList.add("no-scroll");
  //   removeOpenedClass(menu, opener);

  //   handleClickOutside([menu, opener], () => closeNavigationMenu(menu, opener, openableLinks, rightAdditionalLinks));
  // };

  const openNavigationMenu = (menu, opener, openableLinks, rightAdditionalLinks) => {
    menuWrappers.forEach((menuWrapper) => {
      const otherMenu = menuWrapper.querySelector(".navigation-menu");
      const otherOpener = menuWrapper.querySelector(".header__menu-opener-link");
      closeNavigationMenu(otherMenu, otherOpener, openableLinks, rightAdditionalLinks);
    });
  
    menu.classList.add("opened");
    opener.classList.add("opened");
    body.classList.add("no-scroll");
    removeOpenedClass(menu, opener);
  
    const handleClickOutsideHandler = (e) => {
      if (!menu.contains(e.target) && !opener.contains(e.target)) {
        closeNavigationMenu(menu, opener, openableLinks, rightAdditionalLinks);
        document.removeEventListener("click", handleClickOutsideHandler);
      }
    };
  
    document.addEventListener("click", handleClickOutsideHandler);
  };

  const closeNavigationMenu = (menu, opener, openableLinks, rightAdditionalLinks) => {
    if (menu) menu.classList.remove("opened");
    if (opener) opener.classList.remove("opened");
    body.classList.remove("no-scroll");

    openableLinks.forEach((l) => {
      l.classList.remove("opened");
    });

    rightAdditionalLinks.forEach((rightAdditionalLink) => {
      rightAdditionalLink.classList.remove("active");
    });
  };

  if (menuWrappers.length > 0) {
    menuWrappers.forEach((menuWrapper) => {
      const opener = menuWrapper.querySelector(".header__menu-opener-link");
      const closer = menuWrapper.querySelector(".navigation-menu__closer");
      const menu = menuWrapper.querySelector(".navigation-menu");
      const openableLinks = [...menuWrapper.querySelectorAll(".navigation-menu__openable-link")];
      const rightAdditionalLinks = [...document.querySelectorAll(".navigation-menu__additional-links-wrapper")];

      if (openableLinks.length > 0) {
        openableLinks.forEach((openableLink) => {
          openableLink.addEventListener("click", (e) => {
            e.preventDefault();

            openableLinks.forEach((l) => {
              l.classList.remove("opened");
            });

            openableLink.classList.add("opened");
            const linkValue = openableLink.getAttribute('data-link');

            const matchingRightAdditionalLinks = rightAdditionalLinks.find((link) => link.getAttribute('data-link') === linkValue);
            if (matchingRightAdditionalLinks) {
              rightAdditionalLinks.forEach((rightAdditionalLink) => {
                rightAdditionalLink.classList.remove("active");
              })

              matchingRightAdditionalLinks.classList.add("active");
            }
          })
        })
      }

      if (menu) {
        opener.addEventListener("click", (e) => {
          if (menu.classList.contains("opened")) {
              e.preventDefault();
              closeNavigationMenu(opener, menu, openableLinks, rightAdditionalLinks);
            } else {
              e.preventDefault();
              openNavigationMenu(menu, opener, openableLinks, rightAdditionalLinks);
          };
        });

        closer.addEventListener("click", () => {
          closeNavigationMenu(opener, menu, openableLinks, rightAdditionalLinks);
        });
      };
    });
  }
};

export default NavigationMenu;



